import NextLink, { LinkProps } from 'next/link';
import classNames from 'classnames';
import { ComponentProps, FC, ReactNode } from 'react';

export type ILinkProps = LinkProps &
  ComponentProps<'a'> & {
    children: ReactNode;
    hidden?: boolean;
    replace?: boolean;
    scroll?: boolean;
  };

const Link: FC<ILinkProps> = ({
  children,
  className,
  hidden,
  href,
  onClick,
  onMouseEnter,
  onMouseLeave,
  replace,
  rel,
  role,
  scroll,
  shallow,
  target,
  style,
  title,
  ...props
}) => {
  const cls = classNames('link', className);

  href = href ?? '/';
  const client = typeof href === 'object' || href?.startsWith('/');

  const commonProps = {
    className: cls,
    onClick,
    onMouseEnter,
    onMouseLeave,
    rel,
    role,
    scroll,
    shallow,
    style,
    target,
    title,
    hidden,
    ...props,
  };

  if (client) {
    return (
      <NextLink href={href} replace={replace} {...commonProps}>
        {children}
      </NextLink>
    );
  }

  return (
    <a href={href as string} {...commonProps}>
      {children}
    </a>
  );
};

export { Link };
